import axios from "axios";

const instance = axios.create({
  baseURL: "https://api.engineeringprojectskart.com",
});
// const instance = axios.create({ baseURL: "https://api.bostongexotics.com" });

export default instance;
